{
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% बचाएं)",
    "{amount} days free": "{amount} दिन मुफ्त",
    "{amount} off": "{amount} की छूट",
    "{amount} off for first {number} months.": "पहले {number} महीनों के लिए {amount} की छूट।",
    "{amount} off for first {period}.": "पहले {period} के लिए {amount} की छूट।",
    "{amount} off forever.": "हमेशा के लिए {amount} की छूट।",
    "{discount}% discount": "{discount}% छूट",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} को अब {newsletterName} न्यूज़लेटर प्राप्त नहीं होगा।",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} को अब आपके कमेंट्स पर कोई उत्तर देने पर ईमेल नहीं मिलेगा।",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} को अब यह न्यूज़लेटर प्राप्त नहीं होगा।",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} दिन मुफ्त",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "खाता",
    "Account details updated successfully": "खाते की जानकारी सफलतापूर्वक अपडेट की गई",
    "Account settings": "खाता सेटिंग्स",
    "Add a personal note": "एक व्यक्तिगत नोट जोड़ें",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "मुफ्त परीक्षण समाप्त होने के बाद, आपको आपके द्वारा चुने गए स्तर के लिए नियमित कीमत पर शुल्क लिया जाएगा। आप तब तक किसी भी समय रद्द कर सकते हैं।",
    "Already a member?": "पहले से ही सदस्य हैं?",
    "An error occurred": "एक त्रुटि हुई",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "एक अप्रत्याशित त्रुटि हुई। कृपया फिर से प्रयास करें या यदि त्रुटि बनी रहती है तो <a>समर्थन से संपर्क करें</a>।",
    "Back": "वापस",
    "Back to Log in": "लॉगिन पर वापस जाएं",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "ब्लैक फ्राइडे",
    "Bluesky": "",
    "Cancel anytime.": "कभी भी रद्द करें।",
    "Cancel subscription": "सदस्यता रद्द करें",
    "Canceled": "",
    "Cancellation reason": "रद्द करने का कारण",
    "Change": "परिवर्तन",
    "Change plan": "योजना बदलें",
    "Check spam & promotions folders": "स्पैम और प्रचार फ़ोल्डरों की जांच करें",
    "Check with your mail provider": "अपने मेल प्रदाता से जांचें",
    "Check your inbox to verify email update": "ईमेल अपडेट को सत्यापित करने के लिए अपना इनबॉक्स जांचें",
    "Choose": "चुनें",
    "Choose a different plan": "एक अलग योजना चुनें",
    "Choose a plan": "एक योजना चुनें",
    "Choose your newsletters": "अपने न्यूज़लेटर चुनें",
    "Click here to retry": "फिर से प्रयास करने के लिए यहां क्लिक करें",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "बंद करें",
    "Code": "",
    "Comment preferences updated.": "टिप्पणी की प्राथमिकताएं अपडेट की गई।",
    "Comments": "टिप्पणियाँ",
    "Complimentary": "नि:शुल्क",
    "Confirm": "पुष्टि करें",
    "Confirm cancellation": "रद्द करने की पुष्टि करें",
    "Confirm subscription": "सदस्यता की पुष्टि करें",
    "Contact support": "सहायता के लिए संपर्क करें",
    "Continue": "जारी रखें",
    "Continue subscription": "सदस्यता जारी रखें",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "स्ट्राइप चेकआउट सत्र बनाने में असमर्थ",
    "Could not sign in. Login link expired.": "साइन इन नहीं कर सके। लॉगिन लिंक समाप्त हो गया।",
    "Could not update email! Invalid link.": "ईमेल अपडेट नहीं कर सके! अमान्य लिंक।",
    "Create a new contact": "एक नया संपर्क बनाएं",
    "Current plan": "वर्तमान योजना",
    "Delete account": "खाता हटाएं",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "क्या ऐसा करने का इरादा नहीं था? अपनी प्राथमिकताएँ <button>यहाँ</button> प्रबंधित करें।",
    "Don't have an account?": "क्या आपके पास खाता नहीं है?",
    "Edit": "बदलाव करें",
    "Email": "ईमेल",
    "Email confirmation link expired.": "",
    "Email newsletter": "ईमेल न्यूज़लेटर",
    "Email newsletter settings updated": "ईमेल न्यूज़लेटर की सेटिंग्स अपडेट की गई",
    "Email preferences": "ईमेल प्राथमिकताएँ",
    "Email preferences updated.": "ईमेल प्राथमिकताएं अपडेट की गई।",
    "Emails": "ईमेल",
    "Emails disabled": "ईमेल निष्क्रिय",
    "Ends {offerEndDate}": "{offerEndDate} को समाप्त होता है",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "अपना ईमेल दर्ज करें",
    "Enter your name": "अपना नाम दर्ज करें",
    "Error": "त्रुटि",
    "Expires {expiryDate}": "{expiryDate} को समाप्त होता है",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "सदस्यता रद्द करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to log in, please try again": "लॉग इन करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to log out, please try again": "लॉग आउट करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "चेकआउट करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to send magic link email": "जादुई लिंक ईमेल भेजने में विफल",
    "Failed to send verification email": "सत्यापन ईमेल भेजने में विफल",
    "Failed to sign up, please try again": "साइनअप करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to update account data": "खाता डेटा अपडेट करने में विफल",
    "Failed to update account details": "खाता विवरण अपडेट करने में विफल",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "न्यूज़लेटर सेटिंग्स अपडेट करने में विफल",
    "Failed to update subscription, please try again": "सदस्यता अपडेट करने में विफल, कृपया पुनः प्रयास करें",
    "Failed to verify code, please try again": "",
    "Forever": "हमेशा के लिए",
    "Free Trial – Ends {trialEnd}": "मुफ्त परीक्षण – {trialEnd} को समाप्त होता है",
    "Get help": "मदद प्राप्त करें",
    "Get in touch for help": "मदद के लिए संपर्क करें",
    "Get notified when someone replies to your comment": "जब कोई आपके टिप्पणी का उत्तर देता है तो सूचित करें",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "इस पोस्ट पर प्रतिक्रिया दें",
    "Help! I'm not receiving emails": "मदद! मुझे ईमेल नहीं मिल रहे हैं",
    "Here are a few other sites you may enjoy.": "यहाँ कुछ अन्य साइटें हैं जिन्हें आप पसंद कर सकते हैं।",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "यदि किसी न्यूज़लेटर को स्पैम के रूप में चिन्हित किया जाता है, तो उस पते के लिए ईमेल स्वचालित रूप से निष्क्रिय हो जाते हैं ताकि यह सुनिश्चित हो सके कि आपको अब कोई अवांछित संदेश प्राप्त नहीं हो।",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "यदि स्पैम शिकायत दुर्घटनावश थी, या आप फिर से ईमेल प्राप्त करना शुरू करना चाहते हैं, तो आप पिछली स्क्रीन पर बटन पर क्लिक करके ईमेल की सदस्यता पुनः प्राप्त कर सकते हैं।",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "यदि आप अब अपनी सदस्यता रद्द करते हैं, तो आपके पास {periodEnd} तक पहुंच बनी रहेगी।",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "यदि आपके पास एक कॉर्पोरेट या सरकारी ईमेल खाता है, तो अपनी आईटी विभाग से संपर्क करें और उनसे {senderEmail} से ईमेल प्राप्त करने की अनुमति माँगें",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "एक लॉगिन लिंक आपके इनबॉक्स में भेजा गया है। यदि यह 3 मिनट में नहीं आता है, तो कृपया अपना स्पैम फ़ोल्डर जांचें।",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "यदि आप फिर से ईमेल प्राप्त करना शुरू करना चाहते हैं, तो अगला सबसे अच्छा कदम अपने फ़ाइल पर ईमेल पते की किसी भी समस्या के लिए जाँच करना है और फिर पिछली स्क्रीन पर पुनः सदस्यता पर क्लिक करें।",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "यदि आपको वह ईमेल न्यूज़लेटर नहीं मिल रहा है जिसकी आपने सदस्यता ली है, तो यहाँ कुछ चीजें हैं जिन्हें जांचें।",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "यदि आपने इन सभी जाँचों को पूरा कर लिया है और आपको अभी भी ईमेल प्राप्त नहीं हो रहे हैं, तो आप {supportAddress} से संपर्क करके समर्थन प्राप्त कर सकते हैं।",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "यदि न्यूज़लेटर भेजने का प्रयास करते समय एक स्थायी विफलता प्राप्त होती है, तो खाते पर ईमेल निष्क्रिय कर दिए जाएंगे।",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "अपने ईमेल क्लाइंट में {senderEmail} को अपने संपर्क सूची में जोड़ें। यह आपके मेल प्रदाता को संकेत देता है कि इस पते से भेजे गए ईमेल पर विश्वास किया जाना चाहिए।",
    "Invalid email address": "अमान्य ईमेल पता",
    "Invalid verification code": "",
    "Jamie Larson": "राहुल शर्मा",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "इस तरह का कम",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "सुनिश्चित करें कि ईमेल गलती से आपके इनबॉक्स के स्पैम या प्रचार फ़ोल्डरों में समाप्त नहीं हो रहे हैं। यदि वे हैं, तो \"स्पैम नहीं\" और/या \"इनबॉक्स में ले जाएं\" पर क्लिक करें।",
    "Manage": "प्रबंधित करें",
    "Maybe later": "शायद बाद में",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "इस ईमेल डोमेन से सदस्यताएँ वर्तमान में प्रतिबंधित हैं।",
    "Memberships unavailable, contact the owner for access.": "सदस्यता उपलब्ध नहीं है, पहुँच के लिए मालिक से संपर्क करें।",
    "month": "महीना",
    "Monthly": "मासिक",
    "More like this": "इस तरह के और",
    "More options": "",
    "Name": "नाम",
    "Need more help? Contact support": "और अधिक मदद चाहिए? समर्थन से संपर्क करें",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "आपके खाते पर न्यूज़लेटर को दो कारणों से निष्क्रिय किया जा सकता है: एक पिछला ईमेल स्पैम के रूप में चिह्नित किया गया था, या एक ईमेल भेजने का प्रयास एक स्थायी विफलता (बाउंस) के कारण हुआ।",
    "No member exists with this e-mail address.": "इस ईमेल पते के साथ कोई सदस्य मौजूद नहीं है।",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "ईमेल प्राप्त नहीं हो रहे?",
    "Now check your email!": "अब अपना ईमेल जांचें!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "पुनः सदस्यता लेने के बाद, यदि आप अभी भी अपने इनबॉक्स में ईमेल नहीं देखते हैं, तो अपना स्पैम फ़ोल्डर जांचें। कुछ इनबॉक्स प्रदाता पिछली स्पैम शिकायतों का रिकॉर्ड रखते हैं और ईमेल को फ्लैग करना जारी रखेंगे। यदि ऐसा होता है, तो नवीनतम न्यूज़लेटर को 'स्पैम नहीं' के रूप में चिह्नित करें ताकि इसे वापस आपके मुख्य इनबॉक्स में ले जाया जा सके।",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "स्थायी विफलता (बाउंस)",
    "Phone number": "फ़ोन नंबर",
    "Plan": "योजना",
    "Plan checkout was cancelled.": "योजना चेकआउट रद्द कर दिया गया।",
    "Plan upgrade was cancelled.": "योजना उन्नयन रद्द कर दिया गया।",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "अपनी नि:शुल्क सदस्यता को समायोजित करने के लिए कृपया {supportAddress} से संपर्क करें।",
    "Please enter {fieldName}": "कृपया {fieldName} दर्ज करें",
    "Please fill in required fields": "कृपया आवश्यक फ़ील्ड भरें",
    "Podcasts": "",
    "Re-enable emails": "ईमेल पुनः सक्षम करें",
    "Recommendations": "सिफारिशें",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price} पर नवीनीकृत होता है।",
    "Resume subscription": "",
    "Retry": "पुनः प्रयास करें",
    "Save": "सेव करें",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "ईमेल भेजें और नमस्ते कहें!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "{senderEmail} को एक ईमेल भेजें और नमस्ते कहें। यह आपके मेल प्रदाता को संकेत देने में भी मदद कर सकता है कि इस पते से और इस पते पर भेजे गए ईमेल पर विश्वास किया जाना चाहिए।",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "लॉगिन लिंक भेज रहा है...",
    "Sending...": "भेजा जा रहा है...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "सभी दिखाएँ",
    "Sign in": "साइन इन करें",
    "Sign out": "साइन आउट करें",
    "Sign up": "साइनअप करें",
    "Signup error: Invalid link": "साइनअप त्रुटि: अमान्य लिंक",
    "Signups from this email domain are currently restricted.": "इस ईमेल डोमेन से साइनअप वर्तमान में प्रतिबंधित हैं।",
    "Something went wrong, please try again later.": "कुछ गलत हो गया, कृपया बाद में पुनः प्रयास करें।",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "क्षमा करें, अभी कोई अनुशंसाएँ उपलब्ध नहीं हैं।",
    "Sorry, that didn’t work.": "क्षमा करें, वह काम नहीं किया।",
    "Spam complaints": "स्पैम शिकायतें",
    "Start {amount}-day free trial": "{amount}-दिवसीय मुफ्त परीक्षण शुरू करें",
    "Starting {startDate}": "{startDate} से शुरू",
    "Starting today": "आज से शुरू",
    "Submit feedback": "प्रतिक्रिया सबमिट करें",
    "Subscribe": "सदस्यता लें",
    "Subscribed": "सदस्यता ली",
    "Subscription plan updated successfully": "सदस्यता योजना सफलतापूर्वक अपडेट की गई",
    "Success": "सफलता",
    "Success! Check your email for magic link to sign-in.": "सफलता! साइन-इन के लिए जादुई लिंक के लिए अपना ईमेल जांचें।",
    "Success! Your account is fully activated, you now have access to all content.": "सफलता! आपका खाता पूरी तरह से सक्रिय हो गया है, अब आपके पास सभी सामग्री तक पहुंच है।",
    "Success! Your email is updated.": "सफलता! आपका ईमेल अपडेट हो गया है।",
    "Successfully unsubscribed": "सफलतापूर्वक सदस्यता समाप्त की",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "सदस्यता लेने के लिए धन्यवाद। पढ़ना शुरू करने से पहले, नीचे कुछ अन्य साइटें हैं जिन्हें आप पसंद कर सकते हैं।",
    "Thank you for your support": "आपके समर्थन के लिए धन्यवाद",
    "Thank you for your support!": "आपके समर्थन के लिए धन्यवाद!",
    "Thanks for the feedback!": "प्रतिक्रिया के लिए धन्यवाद!",
    "That didn't go to plan": "वह योजना के अनुसार नहीं हुआ",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "हमारे पास आपके लिए ईमेल पता {memberEmail} है — यदि वह सही नहीं है, तो आप इसे अपने <button>खाता सेटिंग्स क्षेत्र</button> में अपडेट कर सकते हैं।",
    "There was a problem submitting your feedback. Please try again a little later.": "आपकी प्रतिक्रिया सबमिट करने में समस्या हुई। कृपया थोड़ी देर बाद फिर से प्रयास करें।",
    "There was an error cancelling your subscription, please try again.": "आपकी सदस्यता रद्द करने में त्रुटि हुई, कृपया पुनः प्रयास करें।",
    "There was an error continuing your subscription, please try again.": "आपकी सदस्यता जारी रखने में त्रुटि हुई, कृपया पुनः प्रयास करें।",
    "There was an error processing your payment. Please try again.": "आपके भुगतान को संसाधित करने में त्रुटि हुई। कृपया पुनः प्रयास करें।",
    "There was an error sending the email, please try again": "ईमेल भेजने में त्रुटि हुई, कृपया पुनः प्रयास करें",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "यह साइट केवल निमंत्रण द्वारा है, पहुँच के लिए मालिक से संपर्क करें।",
    "This site is not accepting donations at the moment.": "यह साइट इस समय दान स्वीकार नहीं कर रही है।",
    "This site is not accepting payments at the moment.": "यह साइट इस समय भुगतान स्वीकार नहीं कर रही है।",
    "This site only accepts paid members.": "यह साइट केवल भुगतान करने वाले सदस्यों को स्वीकार करती है।",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "साइनअप पूरा करने के लिए, अपने इनबॉक्स में पुष्टिकरण लिंक पर क्लिक करें। यदि यह 3 मिनट के भीतर नहीं आता है, तो अपना स्पैम फ़ोल्डर जांचें!",
    "To continue to stay up to date, subscribe to {publication} below.": "नवीनतम जानकारी प्राप्त करने के लिए, नीचे दिए गए {publication} की सदस्यता लें",
    "Too many attempts try again in {number} days.": "बहुत बार प्रयास {number} दिनों में फिर से करें।",
    "Too many attempts try again in {number} hours.": "बहुत बार प्रयास {number} घंटों में फिर से करें।",
    "Too many attempts try again in {number} minutes.": "बहुत बार प्रयास {number} मिनटों में फिर से करें।",
    "Too many different sign-in attempts, try again in {number} days": "बहुत बार साइन-इन करने का प्रयास, {number} दिनों में फिर से करें।",
    "Too many different sign-in attempts, try again in {number} hours": "बहुत बार साइन-इन करने का प्रयास, {number} घंटों में फिर से करें।",
    "Too many different sign-in attempts, try again in {number} minutes": "बहुत बार साइन-इन करने का प्रयास, {number} मिनटों में फिर से करें।",
    "Too many sign-up attempts, try again later": "बहुत बार साइनअप करने का प्रयास, बाद में फिर से करें।",
    "Try free for {amount} days, then {originalPrice}.": "{amount} दिनों के लिए मुफ्त प्रयास करें, फिर {originalPrice}।",
    "Unable to initiate checkout session": "चेकआउट सत्र शुरू करने में असमर्थ",
    "Unlock access to all newsletters by becoming a paid subscriber.": "एक सशुल्क सदस्य बनकर सभी न्यूज़लेटर्स तक पहुंच अनलॉक करें।",
    "Unsubscribe from all emails": "सभी ईमेल से सदस्यता समाप्त करें",
    "Unsubscribed": "सदस्यता समाप्त की",
    "Unsubscribed from all emails.": "सभी ईमेल से सदस्यता समाप्त की।",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "ईमेल से सदस्यता समाप्त करने से आपकी {title} की सशुल्क सदस्यता रद्द नहीं होगी",
    "Update": "अपडेट करें",
    "Update your preferences": "अपनी प्राथमिकताएँ अपडेट करें",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "पुष्टिकरण लिंक भेजा गया, अपना इनबॉक्स जांचें",
    "Verify your email address is correct": "पुष्टि करें कि आपका ईमेल पता सही है",
    "Verifying...": "",
    "View plans": "योजनाएं देखें",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "हम आपको सदस्यता समाप्त नहीं कर सके क्योंकि ईमेल पता नहीं मिला। कृपया साइट मालिक से संपर्क करें।",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "वापसी पर स्वागत है, {name}!",
    "Welcome back!": "वापसी पर स्वागत है!",
    "Welcome to {siteTitle}": "{siteTitle} में आपका स्वागत है",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "जब एक इनबॉक्स एक ईमेल को स्वीकार करने में विफल रहता है तो इसे आमतौर पर बाउंस कहा जाता है। कई मामलों में, यह अस्थायी हो सकता है। हालांकि, कुछ मामलों में, एक बाउंस ईमेल को स्थायी विफलता के रूप में लौटाया जा सकता है जब एक ईमेल पता अमान्य या गैर-मौजूद होता है।",
    "Why has my email been disabled?": "मेरा ईमेल निष्क्रिय क्यों किया गया है?",
    "X (Twitter)": "",
    "year": "वर्ष",
    "Yearly": "वार्षिक",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "आपके पास वर्तमान में एक मुफ्त सदस्यता है, पूर्ण पहुंच के लिए सशुल्क सदस्यता में अपग्रेड करें।",
    "You have been successfully resubscribed": "आपने सफलतापूर्वक पुनः सदस्यता प्राप्त कर ली है",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "आप वर्तमान में ईमेल प्राप्त नहीं कर रहे हैं",
    "You're not receiving emails": "आप ईमेल प्राप्त नहीं कर रहे हैं",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "आप ईमेल प्राप्त नहीं कर रहे हैं क्योंकि आपने हाल की एक संदेश को स्पैम के रूप में चिन्हित किया है, या क्योंकि संदेश आपके द्वारा प्रदान किए गए ईमेल पते पर डिलीवर नहीं किए जा सके।",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "आपने सफलतापूर्वक साइन इन कर लिया है।",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "आपने सफलतापूर्वक सदस्यता ली है <strong>{siteTitle}</strong>",
    "Your account": "आपका खाता",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "आपका ईमेल पुनः सदस्यता लेने में विफल रहा, कृपया पुनः प्रयास करें",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "आपका इनपुट प्रकाशित होने वाली चीज़ों को आकार देने में मदद करता है।",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "आपकी सदस्यता {expiryDate} को समाप्त हो जाएगी",
    "Your subscription will renew on {renewalDate}": "आपकी सदस्यता {renewalDate} को नवीनीकृत होगी",
    "Your subscription will start on {subscriptionStart}": "आपकी सदस्यता {subscriptionStart} को शुरू होगी"
}
